import { render, staticRenderFns } from "./VFirm.vue?vue&type=template&id=4f9ab76e"
import script from "./VFirm.vue?vue&type=script&lang=js"
export * from "./VFirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports